// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AIbyxt {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;
  background: var(--surface-neutral-light, white);
  padding: var(--spacing-8, 64px) var(--spacing-3, 24px);
  gap: var(--spacing-3, 24px);
}

.eW3IR9 {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
}

.Q7oYH0,
.KRLf9m {
  display: flex;
  justify-content: center;
  align-items: center;
}

.N5IoJl {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  background: color-mix(in srgb, var(--primary-orange-500, #d64000) 10%, transparent);
}

.hsmFI3 img {
  width: 16px;
  height: 16px;
  filter: none !important;
}

.JW6QKN img {
  width: 64px;
  height: 64px;
  filter: none !important;
}

.P0ZboF {
  text-align: center;
  max-width: 350px;
}

.wXNBoF,
.Q9HkPO {
  font-family: var(--font-family-primary, 'Source Sans 3');
  font-size: var(--font-size-lg, 16px);
  font-weight: var(--font-weight-semibold, 600);
  line-height: var(--line-height-120, 1.2);
  color: var(--text-neutral-dark, #1f1f1f);
  margin: 0 0 var(--spacing-1, 8px) 0;
}

.Fpjqcc,
.L7mt5k {
  font-family: var(--font-family-primary, 'Source Sans 3');
  font-size: var(--font-size-md, 14px);
  font-weight: var(--font-weight-regular, 400);
  line-height: var(--line-height-120, 1.2);
  color: var(--text-neutral-dark, #1f1f1f);
  margin: 0;
}

.UgjxuS {
  display: flex;
  gap: var(--spacing-1-5, 12px);
  justify-content: center;
}

.ewpXhv {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: var(--spacing-1, 8px);
  padding: var(--spacing-1, 8px) var(--spacing-1-5, 12px);
  border-radius: var(--radius-s, 4px);
  font-family: var(--font-family-primary, 'Source Sans 3');
  font-size: var(--font-size-md, 14px);
  font-weight: var(--font-weight-semibold, 600);
  line-height: var(--line-height-140, 1.4);
  cursor: pointer;
  transition: all 0.2s ease;
  border: 2px solid transparent;
}

.ewpXhv.olA8Ev {
  background: var(--surface-neutral-light, white);
  color: var(--primary-orange-500, #d64000);
  border-color: var(--primary-orange-500, #d64000);
}

.ewpXhv.olA8Ev:hover {
  background: var(--surface-neutral-pale, #f9fafb);
}

.ewpXhv.ma5IDU {
  background: var(--primary-orange-500, #d64000);
  color: var(--surface-neutral-light, white);
  border-color: var(--primary-orange-500, #d64000);
}

.ewpXhv.ma5IDU:hover {
  background: var(--primary-orange-600, #b23a00);
  border-color: var(--primary-orange-600, #b23a00);
}

.Tw8Yzm {
  display: flex;
  flex-direction: column;
  width: 400px;
  background: var(--surface-neutral-light, white);
  border-radius: var(--radius-s, 4px);
  box-shadow: var(--shadow-sm, 0px 2px 4px 0px rgba(0, 0, 0, 0.12));
  height: fit-content;
}

.hOUkkt {
  padding: var(--spacing-3, 24px) var(--spacing-3, 24px) var(--spacing-2, 16px);
}

.Aj_Pue {
  font-family: var(--font-family-primary, 'Source Sans 3');
  font-size: var(--font-size-lg, 16px);
  font-weight: var(--font-weight-regular, 400);
  line-height: var(--line-height-140, 1.4);
  color: var(--text-neutral-dark, #1f1f1f);
  margin: 0;
}

.zsmc3D {
  height: 1px;
  background: var(--stroke-neutral-subtle, #e6e6e6);
  margin: 0 var(--spacing-1-5, 12px);
}

.xbzq2f {
  padding: var(--spacing-3, 24px);
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3, 24px);
}

.l_MWoZ {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1, 8px);
}

.GjpJv0 {
  display: flex;
  align-items: center;
  gap: var(--spacing-1, 8px);
}

.NjNHTR {
  width: 24px;
  height: 24px;
  background: var(--status-success, #387c2b);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.NjNHTR img {
  width: 12px;
  height: 12px;
  filter: brightness(0) invert(1) !important;
}

.iyppa6 {
  font-family: var(--font-family-primary, 'Source Sans 3');
  font-size: var(--font-size-lg, 16px);
  font-weight: var(--font-weight-regular, 400);
  line-height: var(--line-height-140, 1.4);
  color: var(--text-neutral-dark, #1f1f1f);
}

.g5_EEY {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-0-5, 4px);
  margin-left: var(--spacing-4, 32px);
}

.z2hyqo {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--spacing-2, 16px);
}

.fhGrsh {
  font-family: var(--font-family-primary, 'Source Sans 3');
  font-size: var(--font-size-md, 14px);
  font-weight: var(--font-weight-regular, 400);
  line-height: var(--line-height-180, 1.8);
  color: var(--text-neutral-dark, #1f1f1f);
  min-width: 130px;
}

.Go4Wdc {
  font-family: var(--font-family-primary, 'Source Sans 3');
  font-size: var(--font-size-md, 14px);
  font-weight: var(--font-weight-semibold, 600);
  line-height: var(--line-height-180, 1.8);
  color: var(--text-neutral-dark, #1f1f1f);
  text-align: right;
}

.dmzVtn {
  height: 1px;
  background: var(--stroke-neutral-subtle, #f2f2f2);
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/ParametersPage/components/ParametersFeedback/ParametersFeedback.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,OAAO;EACP,+CAA+C;EAC/C,sDAAsD;EACtD,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,mFAAmF;AACrF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,wDAAwD;EACxD,oCAAoC;EACpC,6CAA6C;EAC7C,wCAAwC;EACxC,wCAAwC;EACxC,mCAAmC;AACrC;;AAEA;;EAEE,wDAAwD;EACxD,oCAAoC;EACpC,4CAA4C;EAC5C,wCAAwC;EACxC,wCAAwC;EACxC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,0BAA0B;EAC1B,uDAAuD;EACvD,mCAAmC;EACnC,wDAAwD;EACxD,oCAAoC;EACpC,6CAA6C;EAC7C,wCAAwC;EACxC,eAAe;EACf,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,+CAA+C;EAC/C,yCAAyC;EACzC,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,8CAA8C;EAC9C,0CAA0C;EAC1C,gDAAgD;AAClD;;AAEA;EACE,8CAA8C;EAC9C,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,+CAA+C;EAC/C,mCAAmC;EACnC,iEAAiE;EACjE,mBAAmB;AACrB;;AAEA;EACE,6EAA6E;AAC/E;;AAEA;EACE,wDAAwD;EACxD,oCAAoC;EACpC,4CAA4C;EAC5C,wCAAwC;EACxC,wCAAwC;EACxC,SAAS;AACX;;AAEA;EACE,WAAW;EACX,iDAAiD;EACjD,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,wDAAwD;EACxD,oCAAoC;EACpC,4CAA4C;EAC5C,wCAAwC;EACxC,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,4BAA4B;EAC5B,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,wDAAwD;EACxD,oCAAoC;EACpC,4CAA4C;EAC5C,wCAAwC;EACxC,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,wDAAwD;EACxD,oCAAoC;EACpC,6CAA6C;EAC7C,wCAAwC;EACxC,wCAAwC;EACxC,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iDAAiD;EACjD,SAAS;AACX","sourcesContent":[".feedbackCard {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  flex: 1;\n  background: var(--surface-neutral-light, white);\n  padding: var(--spacing-8, 64px) var(--spacing-3, 24px);\n  gap: var(--spacing-3, 24px);\n}\n\n.loadingContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 200px;\n}\n\n.successIcon,\n.errorIcon {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.iconBackground {\n  width: 72px;\n  height: 72px;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  background: color-mix(in srgb, var(--primary-orange-500, #d64000) 10%, transparent);\n}\n\n.successBackground img {\n  width: 16px;\n  height: 16px;\n  filter: none !important;\n}\n\n.errorBackground img {\n  width: 64px;\n  height: 64px;\n  filter: none !important;\n}\n\n.feedbackContent {\n  text-align: center;\n  max-width: 350px;\n}\n\n.successTitle,\n.errorTitle {\n  font-family: var(--font-family-primary, 'Source Sans 3');\n  font-size: var(--font-size-lg, 16px);\n  font-weight: var(--font-weight-semibold, 600);\n  line-height: var(--line-height-120, 1.2);\n  color: var(--text-neutral-dark, #1f1f1f);\n  margin: 0 0 var(--spacing-1, 8px) 0;\n}\n\n.successMessage,\n.errorMessage {\n  font-family: var(--font-family-primary, 'Source Sans 3');\n  font-size: var(--font-size-md, 14px);\n  font-weight: var(--font-weight-regular, 400);\n  line-height: var(--line-height-120, 1.2);\n  color: var(--text-neutral-dark, #1f1f1f);\n  margin: 0;\n}\n\n.actionButtons {\n  display: flex;\n  gap: var(--spacing-1-5, 12px);\n  justify-content: center;\n}\n\n.button {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: var(--spacing-1, 8px);\n  padding: var(--spacing-1, 8px) var(--spacing-1-5, 12px);\n  border-radius: var(--radius-s, 4px);\n  font-family: var(--font-family-primary, 'Source Sans 3');\n  font-size: var(--font-size-md, 14px);\n  font-weight: var(--font-weight-semibold, 600);\n  line-height: var(--line-height-140, 1.4);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border: 2px solid transparent;\n}\n\n.button.secondary {\n  background: var(--surface-neutral-light, white);\n  color: var(--primary-orange-500, #d64000);\n  border-color: var(--primary-orange-500, #d64000);\n}\n\n.button.secondary:hover {\n  background: var(--surface-neutral-pale, #f9fafb);\n}\n\n.button.primary {\n  background: var(--primary-orange-500, #d64000);\n  color: var(--surface-neutral-light, white);\n  border-color: var(--primary-orange-500, #d64000);\n}\n\n.button.primary:hover {\n  background: var(--primary-orange-600, #b23a00);\n  border-color: var(--primary-orange-600, #b23a00);\n}\n\n.summaryCard {\n  display: flex;\n  flex-direction: column;\n  width: 400px;\n  background: var(--surface-neutral-light, white);\n  border-radius: var(--radius-s, 4px);\n  box-shadow: var(--shadow-sm, 0px 2px 4px 0px rgba(0, 0, 0, 0.12));\n  height: fit-content;\n}\n\n.summaryHeader {\n  padding: var(--spacing-3, 24px) var(--spacing-3, 24px) var(--spacing-2, 16px);\n}\n\n.summaryTitle {\n  font-family: var(--font-family-primary, 'Source Sans 3');\n  font-size: var(--font-size-lg, 16px);\n  font-weight: var(--font-weight-regular, 400);\n  line-height: var(--line-height-140, 1.4);\n  color: var(--text-neutral-dark, #1f1f1f);\n  margin: 0;\n}\n\n.divider {\n  height: 1px;\n  background: var(--stroke-neutral-subtle, #e6e6e6);\n  margin: 0 var(--spacing-1-5, 12px);\n}\n\n.summaryContent {\n  padding: var(--spacing-3, 24px);\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-3, 24px);\n}\n\n.summaryStep {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1, 8px);\n}\n\n.stepHeader {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1, 8px);\n}\n\n.stepIcon {\n  width: 24px;\n  height: 24px;\n  background: var(--status-success, #387c2b);\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.stepIcon img {\n  width: 12px;\n  height: 12px;\n  filter: brightness(0) invert(1) !important;\n}\n\n.stepTitle {\n  font-family: var(--font-family-primary, 'Source Sans 3');\n  font-size: var(--font-size-lg, 16px);\n  font-weight: var(--font-weight-regular, 400);\n  line-height: var(--line-height-140, 1.4);\n  color: var(--text-neutral-dark, #1f1f1f);\n}\n\n.stepDetails {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-0-5, 4px);\n  margin-left: var(--spacing-4, 32px);\n}\n\n.detailRow {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: var(--spacing-2, 16px);\n}\n\n.detailLabel {\n  font-family: var(--font-family-primary, 'Source Sans 3');\n  font-size: var(--font-size-md, 14px);\n  font-weight: var(--font-weight-regular, 400);\n  line-height: var(--line-height-180, 1.8);\n  color: var(--text-neutral-dark, #1f1f1f);\n  min-width: 130px;\n}\n\n.detailValue {\n  font-family: var(--font-family-primary, 'Source Sans 3');\n  font-size: var(--font-size-md, 14px);\n  font-weight: var(--font-weight-semibold, 600);\n  line-height: var(--line-height-180, 1.8);\n  color: var(--text-neutral-dark, #1f1f1f);\n  text-align: right;\n}\n\n.stepDivider {\n  height: 1px;\n  background: var(--stroke-neutral-subtle, #f2f2f2);\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"feedbackCard": `AIbyxt`,
	"loadingContainer": `eW3IR9`,
	"successIcon": `Q7oYH0`,
	"errorIcon": `KRLf9m`,
	"iconBackground": `N5IoJl`,
	"successBackground": `hsmFI3`,
	"errorBackground": `JW6QKN`,
	"feedbackContent": `P0ZboF`,
	"successTitle": `wXNBoF`,
	"errorTitle": `Q9HkPO`,
	"successMessage": `Fpjqcc`,
	"errorMessage": `L7mt5k`,
	"actionButtons": `UgjxuS`,
	"button": `ewpXhv`,
	"secondary": `olA8Ev`,
	"primary": `ma5IDU`,
	"summaryCard": `Tw8Yzm`,
	"summaryHeader": `hOUkkt`,
	"summaryTitle": `Aj_Pue`,
	"divider": `zsmc3D`,
	"summaryContent": `xbzq2f`,
	"summaryStep": `l_MWoZ`,
	"stepHeader": `GjpJv0`,
	"stepIcon": `NjNHTR`,
	"stepTitle": `iyppa6`,
	"stepDetails": `g5_EEY`,
	"detailRow": `z2hyqo`,
	"detailLabel": `fhGrsh`,
	"detailValue": `Go4Wdc`,
	"stepDivider": `dmzVtn`
};
module.exports = ___CSS_LOADER_EXPORT___;
